import { Typography } from "@/components/atoms";

export const ClientHelp = () => {
  return (
    <div className="py-6">
      <Typography variant="h2">Help</Typography>
    </div>
  );
};
